import { OrderStatus } from "../api/endpoints/Order";

const OrderStatusLabel: Map<OrderStatus, string> = new Map([
  [OrderStatus.ACCEPTED, "Quote accepted"],
  [OrderStatus.COMPLETED, "Pending"],
  [OrderStatus.SUBMITTED, "Pending"],
  [OrderStatus.ACTION_REQUIRED, "Pending"],
  [OrderStatus.DRAFT, "Draft"],
  [OrderStatus.REJECTED, "Quote rejected"],
  [OrderStatus.CANCELLED, "Quote cancelled"]
]);

export default OrderStatusLabel;
